import React, { ReactElement } from 'react';
import { SearchFacet, SortOption } from '../../../lib/searchspring/client';
import { useRouter } from 'next/router';
import Filter from './Filter';
import Sort from './Sort';

export default function Filters({
  facets,
  totalResults,
  sticky,
  sortOptions,
  currentSort,
}: {
  facets: SearchFacet[];
  totalResults: number;
  sticky: boolean;
  sortOptions: SortOption[];
  currentSort: SortOption;
}): ReactElement {
  const router = useRouter();
  const filterCount = facets.flatMap((facet) => facet.values.filter((value) => value.active))
    .length;

  const clearAll = (): void => {
    const [url] = router.asPath.split('?');

    router.push({
      pathname: url,
      query: router.query.q ? { q: router.query.q } : null,
    });
  };

  return (
    <section
      aria-label="filters"
      className={`md:px-10 lg:px-16 xl:px-32 py-4 bg-neutral border border-gray-400 ${
        sticky ? 'w-screen' : 'w-auto'
      }`}
    >
      <div className="flex justify-center">
        <div className="flex flex-col w-full">
          <div className="flex justify-between w-full items-center">
            <div className="text-lg font-semibold">Filter by</div>
            <div className="text-sm">
              {totalResults} {totalResults === 1 ? 'Frame' : 'Frames'}
              {filterCount > 0 && (
                <>
                  <span className="px-5">|</span>
                  <span className="inline-flex items-center justify-center h-6 w-6 text-white rounded-full text-xs bg-tertiary">
                    {filterCount}
                  </span>
                  <button onClick={() => clearAll()} className="ml-2 text-tertiary-actual">
                    Clear all
                  </button>
                </>
              )}
              {sticky && (
                <Sort
                  sortOptions={sortOptions}
                  currentSort={currentSort}
                  sticky={sticky}
                  isMobile={false}
                />
              )}
            </div>
          </div>
          <div className="flex flex-wrap -mx-5">
            {facets.map((facet) => (
              <Filter key={facet.field} {...facet} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
